import Query from '../../components/Report';

const query = (category) =>
    new Query('discover-competitive-analysis', {
        category,
    });

export default query;
